import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { FirmwareOverviewModel } from '../../../models/firmware-overview.model';
import { getFirmwaresSelector } from '../../../selectors/get-firmwares-selector/get-firmwares.selector';
import { getFirmwares } from '../get-firmwares.thunk';

export const useGetFirmwares = (
  firmwareIds: number[]
): FirmwareOverviewModel[] => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!firmwareIds.length) {
      dispatch(getFirmwares());
    }
  }, []);

  return useAppSelector(getFirmwaresSelector);
};
